import { authenticatedFetch } from '../../../api/request';

export default async function getAllMotives(doctorId, setErrorMessage) {
    const onError = () => setErrorMessage('No se puede obtener los motivos de consulta.');
    return await authenticatedFetch(`/doctor-profile-management/all-motives/${doctorId}`, onError);
}
